module.exports = "https://static.wmbcdn.com/uniweb/images/dab070d763f9c61dbcf2ecd87b84771d.svg";